import styled from 'styled-components';
import {ScrollBar} from '../../../shared-components/mixin/scroll/scrollBar';

export const NoneEntityDetail = styled(ScrollBar)`
    overflow-y: auto;
    overflow-x: hidden;
    padding: var(--grid-padding);
    grid-area: detail;
    @-moz-document url-prefix() {
        overflow-y: auto;
        scrollbar-color: var(--scroll-bar-background) var(--scroll-bar-thumb);
    }
`;

export const TableSelectedBadge = styled.div`
    padding: var(--space-md) var(--grid-padding);
    grid-area: selectedBadge;
`;
